/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { PageState } from '@myob/myob-widgets';

const OnAccountPaymentView: React.FC = () => (
    <PageState
        title="Your payment details are listed as 'on account'."
        description="Chat to your partner manager to make any changes."
    />
);
export default OnAccountPaymentView;
